import { AccountInfo, Configuration, InteractionRequiredAuthError, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import { user, authInitialized, isAuthenticated } from './authStore';
import { loginRequest, msalConfig } from './authConfig';
import { errorStore } from '../defaults/errorStore';

export class Authenticator {

    private msalInstance: PublicClientApplication;
    private account: AccountInfo | null
    private request: RedirectRequest;

    constructor(config: Configuration, request: RedirectRequest) {

        this.request = request;
        this.msalInstance = new PublicClientApplication(config);
        this.account = null;
    }

    
    public async initialize() : Promise<void> {
        await this.msalInstance.initialize()
        await this.handleRedirectPromise();
    }
    
    public login(): void {
        this.msalInstance.loginRedirect(this.request);
    }

    public async handleRedirectPromise(): Promise<void> {

        try {
            
            const response = await this.msalInstance.handleRedirectPromise();
            if (response) {
                this.account = response.account;

                isAuthenticated.set(true);
                user.set(this.account);
            } else {
              this.account = this.msalInstance.getAllAccounts()[0];
              if (this.account) {
                isAuthenticated.set(true);
                user.set(this.account);
              }
            }

        } catch (error) {
            console.error("Redirect error", error);
            this.account = null;
            isAuthenticated.set(false);
            user.set(null);
        } finally {
            authInitialized.set(true);
        }
    }

    async getToken(): Promise<string | null> {

        let account = this.account;
        if( !account ) {
            account = this.msalInstance.getAllAccounts()[0];
        }

        if (!account) {
            return null;
        }
        
        const silentRequest = {
            scopes: this.request.scopes,
            account: account,
        };

        try {
            const response = await this.msalInstance.acquireTokenSilent(silentRequest);
            return response.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                
                try {
                    await this.msalInstance.acquireTokenRedirect(silentRequest);
                    return null;
                } catch (redirectError) {
                    console.error("Erreur lors de la redirection pour obtenir le jeton d'accès :", redirectError);
                    errorStore.set(redirectError as Error);
                    throw redirectError;
                }
            } else {
                console.error("Erreur lors de l'acquisition du jeton d'accès silencieux :", error);
                errorStore.set(error as Error);
                throw error;
            }
        }
    }

    logout(): void {
        // Choose which account to logout from by passing a username.
        const logoutRequest = {
            account: this.account,
            //postLogoutRedirectUri: '/signout', // remove this line if you would like navigate to index page after logout.

        };

        this.msalInstance.logoutRedirect(logoutRequest);
    }
}


export const msalAuthenticator: Authenticator = new Authenticator(msalConfig, loginRequest);